module.exports = __webpack_public_path__ + "static/media/android.cae623d1.png";